import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: theme.spacing(140),
    [theme.breakpoints.down('xs')]: {
      height: '100%',
      minWidth: 0,
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.header.main,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  actionButton: {
    margin: theme.spacing(3),
  },
  saveButton: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },
}));

const CredentialResend = ({ visible, dismiss, confirm }) => {
  const classes = useStyles();

  return (
    <Modal
      className={classes.modal}
      open={visible}
      onClose={() => {
        dismiss();
      }}
    >
      <div className={classes.paper}>
        <IconButton
          disableRipple
          onClick={() => {
            dismiss();
          }}
        />
        <h2>Resend mobile credential text?</h2>
        <span>
          <Typography>
            This will send another mobile credential registration text message to the associated
            phone.
          </Typography>
        </span>
        <div>
          <Button
            className={[classes.actionButton, classes.saveButton]}
            variant="contained"
            onClick={() => {
              confirm();
              dismiss();
            }}
          >
            Send
          </Button>
          <Button
            className={classes.actionButton}
            onClick={() => {
              dismiss();
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CredentialResend;
